import { PersonalPlanningChannelPayload } from "./personalPlanningChannel.reducer"

export enum Types {
  CONNECT = "PERSONAL_PLANNING_TIMESLOTSCHANNEL_CONNECT",
  CONNECTION_SUCCESS = "PERSONAL_PLANNING_TIMESLOTSCHANNEL_CONNECTION_SUCCESS",
  CONNECTION_FAILED = "PERSONAL_PLANNING_TIMESLOTSCHANNEL_CONNECTION_FAILED",
  DISCONNECT = "PERSONAL_PLANNING_TIMESLOTSCHANNEL_DISCONNECT",
  DISCONNECT_SUCCESS = "PERSONAL_PLANNING_TIMESLOTSCHANNEL_DISCONNECT_SUCCESS",
  DISCONNECT_FAILED = "PERSONAL_PLANNING_TIMESLOTSCHANNEL_DISCONNECT_FAILED",
}

export type Action =
  | ConnectTimeslotsChannelAction
  | ConnectionTimeslotsChannelSuccessAction
  | ConnectionTimeslotsChannelFailAction
  | DisconnectTimeslotsChannelAction
  | DisconnectTimeslotsChannelSuccessAction
  | DisconnectTimeslotsChannelFailAction

export type ConnectTimeslotsChannelAction = {
  payload: PersonalPlanningChannelPayload
  type: Types.CONNECT
}

export type ConnectionTimeslotsChannelSuccessAction = {
  type: Types.CONNECTION_SUCCESS
}

export type ConnectionTimeslotsChannelFailAction = {
  payload: { errors: object }
  type: Types.CONNECTION_FAILED
}

export type DisconnectTimeslotsChannelAction = {
  type: Types.DISCONNECT
}

export type DisconnectTimeslotsChannelSuccessAction = {
  type: Types.DISCONNECT_SUCCESS
}

export type DisconnectTimeslotsChannelFailAction = {
  payload: { errors: object }
  type: Types.DISCONNECT_FAILED
}

export function connectTimeslotsChannel(payload: PersonalPlanningChannelPayload): ConnectTimeslotsChannelAction {
  return {
    payload,
    type: Types.CONNECT,
  }
}

export function connectionTimeslotsChannelSuccess(): ConnectionTimeslotsChannelSuccessAction {
  return {
    type: Types.CONNECTION_SUCCESS,
  }
}

export function connectionTimeslotsChannelFail(errors: object): ConnectionTimeslotsChannelFailAction {
  return {
    payload: { errors },
    type: Types.CONNECTION_FAILED,
  }
}

export function disconnectTimeslotsChannel(): DisconnectTimeslotsChannelAction {
  return {
    type: Types.DISCONNECT,
  }
}

export function disconnectTimeslotsChannelSuccess(): DisconnectTimeslotsChannelSuccessAction {
  return {
    type: Types.DISCONNECT_SUCCESS,
  }
}

export function disconnectTimeslotsChannelFail(errors: object): DisconnectTimeslotsChannelFailAction {
  return {
    payload: { errors },
    type: Types.DISCONNECT_FAILED,
  }
}
